// extracted by mini-css-extract-plugin
export default {"variablesDialog":"VariablesDialog-module__variablesDialog--YK_DF","DialogOverflowWrapper":"VariablesDialog-module__DialogOverflowWrapper--a9SDs"};